/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Collapse as MuiCollapse, CollapseProps } from '@mui/material'

interface PropsType extends CollapseProps {}

export const Collapse = (props: PropsType) => {
	return (
		<MuiCollapse css={style} {...props} timeout="auto">
			{props.children}
		</MuiCollapse>
	)
}

const style = css({})
